module.exports = __webpack_public_path__ + "img/collection-engagementRingsCharacter.e285ab1.jpg";